import { DAY_PRESETS, RANGE_PRESETS } from '../../constants';
import { getRangeForTimespan } from './getRangeForTimespan';
import { getDateString } from './getDateString';

export const getTimespanFromRange = (
  from: any,
  to: any,
  allowRange: boolean
) => {
  const timespans = (allowRange ? RANGE_PRESETS : DAY_PRESETS) as Array<any>;
  const foundNamedRange = timespans.find(({ id }) => {
    const range = getRangeForTimespan(id);
    if (!range || !range.from) {
      return false;
    }
    if (allowRange) {
      return (
        from &&
        range.from &&
        getDateString(from) === getDateString(range.from) &&
        to &&
        range.to &&
        getDateString(to) === getDateString(range.to)
      );
    } else {
      return getDateString(range.from) === getDateString(from);
    }
  });
  return foundNamedRange;
};
